// Ids match M5 reseed (20260729190000_firestore_migration_seeds): DELETE + re-INSERT with
// no explicit ids, continuing autoincrement past the 4 rows from seed_enumerations.
export var CustomerStatus;
(function (CustomerStatus) {
    CustomerStatus[CustomerStatus["COLD_LEAD"] = 5] = "COLD_LEAD";
    CustomerStatus[CustomerStatus["HOT_LEAD"] = 6] = "HOT_LEAD";
    CustomerStatus[CustomerStatus["ON_HOLD_LEAD"] = 7] = "ON_HOLD_LEAD";
    CustomerStatus[CustomerStatus["SAMPLES_SENT"] = 8] = "SAMPLES_SENT";
    CustomerStatus[CustomerStatus["SAMPLES_RECEIVED"] = 9] = "SAMPLES_RECEIVED";
    CustomerStatus[CustomerStatus["ACTIVE_CURRENT_PAYMENTS"] = 10] = "ACTIVE_CURRENT_PAYMENTS";
    CustomerStatus[CustomerStatus["ACTIVE_ORDERS_UNDER_HUB_ACCOUNT"] = 11] = "ACTIVE_ORDERS_UNDER_HUB_ACCOUNT";
    CustomerStatus[CustomerStatus["ACTIVE_DELINQUENT_PAYMENTS"] = 12] = "ACTIVE_DELINQUENT_PAYMENTS";
    CustomerStatus[CustomerStatus["INACTIVE_NEEDS_REONBOARDING"] = 13] = "INACTIVE_NEEDS_REONBOARDING";
    CustomerStatus[CustomerStatus["PAYMENT_PLAN_ACTIVELY_ORDERING"] = 14] = "PAYMENT_PLAN_ACTIVELY_ORDERING";
    CustomerStatus[CustomerStatus["PAYMENT_PLAN_NO_ORDERS"] = 15] = "PAYMENT_PLAN_NO_ORDERS";
    CustomerStatus[CustomerStatus["CREDIT_HOLD"] = 16] = "CREDIT_HOLD";
    CustomerStatus[CustomerStatus["OUT_OF_BUSINESS"] = 17] = "OUT_OF_BUSINESS";
    CustomerStatus[CustomerStatus["DO_NOT_CALL"] = 18] = "DO_NOT_CALL";
})(CustomerStatus || (CustomerStatus = {}));
//# sourceMappingURL=customer-status.js.map